import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const formStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            display: "flex",
            flexDirection: "column",
        },

        input: {
            marginBottom: "15px",
            width: "350px",
        },

        submitButton: {
            marginBottom: "15px",
            alignSelf: "end",
        },

        error: {
            color: theme.colors.feedback.error,
            maxWidth: "350px",
        },

        loadingIndicator: {
            width: "350px",
            padding: "75px",
        },

        selectChip: {
            margin: "2px",
        },

        dropdown: {
            margin: "0px",
            marginBottom: "15px",
            maxWidth: "initial",
        },
    })
);
